

<template>

  <div class="outer-wrap">

      <transition name="slide" mode="out-in">

        <router-view :slug=" slug " id="menu-body"></router-view>
      </transition>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';

  export default {

    name: 'home',
    props : {

      slug : String
    },
    computed: {

      ...mapGetters({

        isAuth      : 'auth/isAuth',
        profileInfo : 'auth/profileInfo'
      })
    },
    created(){

      console.log( 'created!' );
      if( this.isAuth && ( Object.values( this.profileInfo ).length > 0 && this.profileInfo.userId == null ) ){
        // this condition will exist when the user has a JWT but has not yet initialized the app..
        // this occurs when the user is just entering via text-auth, or by the standard login process

        this.$store.dispatch( 'auth/initApp' );
      }
    }
  }
</script>

<style scoped>

  .outer-wrap {

    margin: 0px auto;
    width: 100%;
    max-width: 500px;
    height: 100%;
  }
</style>
